import React from "react";
import { Link } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
import { useAppSelector } from "../Hooks";
import { useTranslation } from "react-i18next";
import { IFooter, IQuickLink } from "../types/features/multiLanguageSlice";

const Footer: React.FC = () => {
    const { footer } = useAppSelector(state => state.footer);
    const {t} = useTranslation()
    console.log(footer, 'footer');
const quick_link_json = t('footer.quick_links', { returnObjects: true })  as IQuickLink[];

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (
        <div>
            <footer className="footer">
                <div className="container">
                    <Row>
                        <Col md={4}>
                            <div className="footer-content">
                                <h3 className="title">{t('about_us.title')}</h3>
                                <p className="text">{t('footer.about_description')}</p>
                                <h4 className="media-title">{t('footer.get_social')}</h4>
                                <ul className="social-media">
                                    {footer && footer?.socials && footer?.socials.length>0 && footer?.socials.map((social) =>
                                        <li><Link to={social.link}><i className="fa fa-facebook" aria-hidden="true"></i></Link></li>
                                    )
                                    }
                                    {/* <li><Link to="https://x.com"><i className="fa fa-twitter" aria-hidden="true"></i></Link></li>
                                    <li><Link to="https://www.youtube.com/"><i className="fa fa-youtube-play" aria-hidden="true"></i></Link></li>
                                    <li><Link to="https://www.instagram.com/"><i className="fa fa-instagram" aria-hidden="true"></i></Link></li>
                                    <li><Link to="https://www.google.com/"><i className="fa fa-google" aria-hidden="true"></i></Link></li> */}
                                </ul>
                            </div>
                        </Col>
                        <Col md={3} className="offset-md-1">
                            <div className="footer-content">
                                <h3 className="title">{t('footer.quick_link')}</h3>
                                <ul className="footer-navbar">
                                    {quick_link_json &&  quick_link_json.length>0 && quick_link_json.map((quick_link) => (

                                        <li><Link to={quick_link.link} onClick={scrollToTop}>{quick_link.name}</Link></li>
                                    ))}
                                    {/* <li><Link to="/about-us" onClick={scrollToTop}>About Us</Link></li>
                                    <li><Link to="/room-suits" onClick={scrollToTop}>Room & Suits</Link></li>
                                    <li><Link to="/dinning" onClick={scrollToTop}>Dinning</Link></li>
                                    <li><Link to="/meetings-events" onClick={scrollToTop}>Mitting & Events</Link></li>
                                    <li><Link to="/blogs" onClick={scrollToTop}>Blog</Link></li>
                                    <li><Link to="/contact" onClick={scrollToTop}>Contact</Link></li> */}

                                </ul>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="footer-content">
                                <h3 className="title">{t('footer.contact_us')}</h3>
                                <div className="contact-details">
                                    <p className="address">{t('footer.address')}</p>
                                    <h5 className="call-title">{t('footer.call_us')}</h5>
                                    <Link to="tel:+1-978-288-5625" className="call-number">{t('footer.phone')}</Link>
                                    <Link to="mailto:info@ebreazehotel.com" className="mail">{t('footer.email')}</Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </footer>
            <div className="copyright-footer">
                <div className="container">
                    <Row>
                        <Col sm={10}>
                            <div className="copyright-text">
                                <p>© 2024 The <Link to="#">Ebreaze</Link> Hotel service. All rights reserved.</p>
                            </div>
                        </Col>
                        <Col sm={2}>
                            <Link to="#" onClick={scrollToTop} className="up-arrow">
                                <i className="fa fa-chevron-up" aria-hidden="true"></i>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}
export default Footer;